import {
  UPDATE_CHANNEL_VOICE_STATUS,
  SET_LATEST_VOICE_STATUS_BEFORE_DISCONNECT,
} from '@/store/mutation-types';

import {
  enterAgentVoiceChannel,
  leaveAgentVoiceChannel,
} from '@/services/channel-service';

const actions = {
  setConnectedInVoice({ commit, dispatch }) {
    commit(UPDATE_CHANNEL_VOICE_STATUS, 'available');
    // dispatch('showSnackbar', { text: 'voiceChannel.loggedInChannel-voice', type: 'success' }, { root: true })
  },

  setDisconnectVoiceChannel({ dispatch, commit }) {
    commit(UPDATE_CHANNEL_VOICE_STATUS, 'disconnected');
    dispatch(
      'showSnackbar',
      { text: 'voiceChannel.disconnectChannel-voice', type: 'success' },
      { root: true },
    );
  },

  connectVoice({ dispatch }, { agentId, exten }) {
    return enterAgentVoiceChannel({ agentId, exten }).catch((err) => {
      const response = err.response.data;
      const text = response.cause
        ? response.cause
        : 'errorDisconnectChannel-voice';

      if (
        response.cause &&
        response.cause != 'online' &&
        response.cause != 'originate'
      ) {
        dispatch(
          'showSnackbar',
          { text: `voiceChannel.${text}`, type: 'error' },
          { root: true },
        );
      }
    });
  },

  disconnectVoice({ dispatch }, agentId) {
    return leaveAgentVoiceChannel(agentId)
      .then((res) => {
        console.log(res);
        const text = {
          text: res.data.reason
            ? `logoff.${res.data.reason}`
            : 'voiceChannel.errorDisconnectChannel-voice',
          type: 'error',
        };
        dispatch('showSnackbar', text, { root: true });
      })
      .catch((err) => {
        const response = err.response.data;
        const text = {
          text: response.voice.voiceReason
            ? response.voice.voiceReason
            : 'voiceChannel.errorDisconnectChannel-voice',
          type: 'error',
        };
        dispatch('showSnackbar', text, { root: true });
      });
  },
  setLatestStatusBeforeDisconnect({ commit, rootState }, reset = false) {
    let statusVoice = {
      description: '',
      status: '',
    };

    if (rootState.channel.channels.voice.status == 'available') {
      statusVoice.description = '';
      statusVoice.status = 'available';
    }

    if (
      (rootState.pause.activePauses.voice.length > 0 &&
        rootState.channel.channels.voice.status == 'paused') ||
      rootState.channel.channels.voice.status == 'scheduled_pause'
    ) {
      statusVoice.description = rootState.pause.activePauses.voice;
      statusVoice.status = rootState.channel.channels.voice.status;
    }

    if (reset) {
      statusVoice.description = '';
      statusVoice.status = '';
    }

    commit(SET_LATEST_VOICE_STATUS_BEFORE_DISCONNECT, statusVoice);
  },
};

export default actions;
